import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { useTranslation } from 'react-i18next';

import { USER_ROLES } from 'constants/common';

import { showToast } from 'helpers/showToast';
import { getTranslation } from 'helpers/getTranslation';
import { getUnknownErrorMessage } from 'helpers/unknownErrorMessage';

import { updateStudentById } from 'store/student/actions';

import { userSelector } from 'store/auth/selectors';
import { currentStudentSelector } from 'store/student/selectors';

import { convertDataToApi } from './EditStudent.helpers';

import EditStudent from './EditStudent';

const EditStudentContainer = ({
  onClose,
  ...restProps
}: { onClose: any } & Record<string, any>) => {
  const dispatch = useAppDispatch();
  const { i18n } = useTranslation();

  const user = useAppSelector(userSelector);
  const currentStudent = useAppSelector(currentStudentSelector);

  const [saveLoading, setSaveLoading] = useState(false);

  if (!currentStudent) {
    return null;
  }

  const handleSaveClick = async (values: any) => {
    setSaveLoading(true);

    try {
      await dispatch(
        updateStudentById({
          studentId: currentStudent.id,
          data: convertDataToApi(values),
        }),
      ).unwrap();

      showToast({
        data: {
          variant: 'success',
          title: getTranslation('common.toast.student_updated.title'),
          text: getTranslation('common.toast.student_updated.text'),
        },
      });

      onClose();
    } catch (error) {
      console.warn(error);

      showToast({
        data: {
          variant: 'error',
          title: getTranslation('common.toast.error.title'),
          text: getUnknownErrorMessage(
            error,
            getTranslation('common.toast.error.text'),
          ),
        },
      });
    }

    setSaveLoading(false);
  };

  const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

  return (
    <EditStudent
      {...restProps}
      locale={i18n.language}
      saveLoading={saveLoading}
      isRootAdmin={isRootAdmin}
      currentStudent={currentStudent}
      onClose={onClose}
      onSaveClick={handleSaveClick}
    />
  );
};

export default React.memo(EditStudentContainer) as any;
